import * as React from 'react'
import { Drawer, Button, Icon } from '@blueprintjs/core'
import ProductView from '../components/ProductView'

type Props = {
  quickView?: number
  onQuickViewClose: (event: React.SyntheticEvent<HTMLElement>) => void
  setParentState: Function
  onDuplicate: Function
}

export const ProductDrawer = ({ quickView, onQuickViewClose, setParentState, onDuplicate }: Props): JSX.Element => {
  return (
    <Drawer
      size={Drawer.SIZE_STANDARD}
      isOpen={quickView !== undefined}
      enforceFocus
      hasBackdrop
      usePortal
      style={{ overflow: 'scroll' }}
      autoFocus
      canEscapeKeyClose
      canOutsideClickClose
      onClose={onQuickViewClose}
    >
      <div className="close">
        <Button minimal onClick={onQuickViewClose}>
          <Icon icon="cross" iconSize={25} />
        </Button>
      </div>
      <ProductView
        productId={quickView}
        onProductChange={product => {
          setParentState(s => {
            return {
              data: s.data.map((d: any) => {
                if (d.id === product.id) return { ...d, ...product }
                return d
              })
            }
          })
        }}
        onRecycle={(id: number) => setParentState({ recycleDialogId: id })}
        onRestore={(id: number) => setParentState({ restoreDialogId: id })}
        onDelete={(id: number) => setParentState({ deleteDialogId: id })}
        onDuplicate={onDuplicate || null}
      />
    </Drawer>
  )
}
